module.exports = __webpack_public_path__ + "img/bg_f.06863390.png";